/**
 * What a business uses of TRUE (Receipt-Web-Server management/features.py): its kind of business and the modules its
 * dashboard shows. Off only hides a module; a module in use always shows; a business that never chose sees everything.
 */
export type ModuleKey = 'orders' | 'encargos' | 'loyalty' | 'promotions' | 'inventory' | 'options' | 'balance' | 'kitchen';

export type Features = {
  business_type: string;
  /** False until the owner chooses: everything shows. */
  configured: boolean;
  modules: { key: ModuleKey; label: string; description: string; chosen: boolean; in_use: string | null; on: boolean }[];
  types: { key: string; label: string; description: string; modules: ModuleKey[] }[];
};

/** Whether the dashboard shows a module (everything shows while the features haven't loaded or on older servers). */
export const moduleOn = (features: Features | null | undefined, key: ModuleKey) =>
  !features ? true : features.modules.find(m => m.key === key)?.on ?? true;
